import clsx from "clsx";
import React, { useCallback, useRef } from "react";
import { Button, Modal } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import Back from "~/components/Icons/arrow-prev2";
import IconCopy from "~/components/Icons/icon-copy";
import IconEdit from "~/components/Icons/icon-edit-pen";
import Preloader from "~/components/Preloader";
import Table from "~/components/Table";
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import Switch from "~/components/UI/Switch";
import useCopyRole from "~/pages/RegistryOfRole/hooks/useCopyRole";
import useGetDescriptionsRole from "~/pages/RegistryOfRole/hooks/useGetDescriptionsRole";
import useGetModelRole from "~/pages/RegistryOfRole/hooks/useGetModelRole";
import useUpdateRole from "~/pages/RegistryOfRole/hooks/useUpdateRole";
import useUpdateRoleStatus from "~/pages/RegistryOfRole/hooks/useUpdateRoleStatus";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { CopyRoleModal } from "~/pages/RegistryOfRole/CopyRoleModal";
import { usePermissions } from "~/shared/context/PermissionContext";
import { useNotify } from "~/shared/hooks/useNotify";

import s from "./RegistryOfRole.less";

const RegistryOfRole = () => {
  const { t } = useTranslation();
  const isRu = localStorage.getItem("language") === "ru";
  const { params } = useRouteMatch();
  const { notifyError } = useNotify();

  const DealerId = params["id"];
  const idArchive = params["period"];
  const history = useHistory();
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const isAdd = DealerId === "add";
  const { openChildModal } = useGetLocationData();
  const setData = useSetLocationData();
  const setDataModal = useSetLocationData(true);

  const { watch } = useForm();

  const { data, isLoading, refetch } = useGetDescriptionsRole();
  const {
    data: dataModel,
    isLoading: loadingModel,
    refetch: refetchModel,
  } = useGetModelRole();

  const updateRoleMutation = useUpdateRole();
  const updateRoleStatusMutation = useUpdateRoleStatus();
  const method = useForm();
  const { copyRoleMutation, copyRoleId, setCopyRoleId, doCopy } = useCopyRole(
    "Error copying role:",
  );

  const rowValuesDecorator = (value, optionName, item) => {
    const previousValueRef = useRef(item.isActive);
    if (optionName === "isActive") {
      return (
        <Switch
          name={`roles.${item.id}.status`}
          control={method.control}
          defaultValue={item.isActive}
          disabled={
            !item.canBeDeactivated ||
            (item.canBeDeactivated &&
              !hasPermission("users.access.change.active"))
          }
          onChange={(newValue) => {
            previousValueRef.current = item.isActive;
            updateRoleStatusMutation.mutate(
              { id: item.id, roleData: { isActive: newValue, id: item.id } },
              {
                onSuccess: () => {
                  console.log("Role status updated successfully");
                },
                onError: (error) => {
                  console.error("Error updating role status:", error);
                  notifyError(error?.[`message`]);
                  method.reset({
                    [`roles.${item.id}.status`]: previousValueRef.current,
                  });
                },
              },
            );
          }}
        />
      );
    }
    if (optionName === "btn") {
      return (
        <div className={s.btnWrapper}>
          {hasPermission("users.access.roles.copy") && (
            <div onClick={() => setCopyRoleId(item.id)}>
              <IconCopy />
            </div>
          )}
          {hasPermission("users.access.roles.edit") && (
            <div onClick={() => history.push(`/registry_of_role/${item.id}`)}>
              <IconEdit />
            </div>
          )}
        </div>
      );
    }
    if (optionName === "modules") {
      const uniqueModules = item.modules.filter(
        (el, index, array) =>
          array.findIndex((item) => item.description === el.description) ===
          index,
      );
      return (
        <div className={s.wrapperModules}>
          {uniqueModules.map((el, index) => (
            <span key={index}>{el.description};</span>
          ))}
        </div>
      );
    }

    return value;
  };

  const closeModalUser = () => {
    (refetchModel(), setData("openChildModal", ""));
  };

  const redirectToUserProfilePersonal = useCallback(
    () => history.push(`/`),
    [history],
  );
  const breadcrumbItems = [
    { link: "/", name: "Главная" },
    { link: "", name: "Регистр ролей моделей" },
  ];
  if (isLoading) {
    return <Preloader />;
  }

  return (
    <>
      <div className={s.wrapperBlock}>
        <Breadcrumbs
          items={breadcrumbItems}
          onClickHandler={redirectToUserProfilePersonal}
        />
        <div className={s.btn} onClick={redirectToUserProfilePersonal}>
          <Back /> Назад
        </div>
        <div className={s.s_user_title}>
          <div>реестр ролевых моделей</div>
          {hasPermission("users.access.roles.create") && (
            <Button
              onClick={() => history.push(`/registry_of_role/add`)}
              size={"middle"}
            >
              Добавить роль
            </Button>
          )}
        </div>
        {dataModel ? (
          <div
            className={clsx({
              [s.wrapper]: true,
            })}
          >
            <Table
              items={dataModel.roles}
              options={["name", "modules", "isActive", "btn"]}
              type={"roles"}
              customClassName={s.table}
              rowValuesDecorator={rowValuesDecorator}
              sortable={false}
            />
          </div>
        ) : (
          <div className={s.error_not_dealer}>
            {" "}
            {t(`dealers.error_not_dealer`)}
          </div>
        )}
      </div>
      <CopyRoleModal
        copyRoleId={copyRoleId}
        setCopyRoleId={setCopyRoleId}
        copyRoleMutation={copyRoleMutation}
        doCopy={doCopy}
        openChildModal={openChildModal}
        closeModalUser={closeModalUser}
      />
    </>
  );
};

export default RegistryOfRole;
